import { Routes } from '@angular/router';
import { AccountMappingComponent } from './account-mapping/account-mapping.component';
import { LayoutComponentComponent } from './layout-component/layout-component.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { GeneralComponent } from './general/general.component';
import { UsersComponent } from './users/users.component';
import { AuthGuard } from './auth.guard';
import { KpisComponent } from './kpis/kpis.component';
import { NotebooksComponent } from './Jobs/notebooks/notebooks.component';
import { PipelinesComponent } from './Jobs/pipelines/pipelines.component';

export const routes: Routes = [
  { path: '', component: LandingPageComponent },
  {
    path: '', component: LayoutComponentComponent,
    children: [
      { path: 'home', component: GeneralComponent, canActivate: [AuthGuard] },
      { path: 'accountMapping', component: AccountMappingComponent, canActivate: [AuthGuard] },
      { path: 'users', component: UsersComponent, canActivate: [AuthGuard] },
      { path: 'kpis', component: KpisComponent, canActivate: [AuthGuard] },
      { path: 'notebooks', component: NotebooksComponent, canActivate: [AuthGuard] },
      { path: 'pipelines', component: PipelinesComponent, canActivate: [AuthGuard] },
    ]
  },
  { path: '**', redirectTo: '/accountMapping' }
];
